import React, { HTMLAttributes } from 'react';
import TableActions from './Actions';
import TableCell from './Cell';
import TableHeaderCell from './HeaderCell';
import TablePagination from './Pagination';
import TableRow from './Row';
import styles from './styles.module.scss';

interface TableProps extends HTMLAttributes<HTMLTableElement> {
    fluid?: boolean,
}

class Table extends React.Component<TableProps> {
    static Actions = TableActions;
    static Cell = TableCell;
    static HeaderCell = TableHeaderCell;
    static Pagination = TablePagination;
    static Row = TableRow;
    
    render = (): JSX.Element => {
        const { children, className, fluid, ...rest } = this.props;

        return (
            <table
                className={[
                    styles.base,
                    fluid && styles.fluid,
                    className,
                ].join(' ')}
                {...rest}
            >
                {children}
            </table>
        );
    }
}

export default Table;
